import React from 'react'
import { AvatarProps } from './types'
import resolveProps from '../../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'sm',
      isDefault: true
    },
    'md',
    'lg'
  ],
  modifiers: ['picture', 'action']
}

const renderNotication = (notificationCount) => {
  notificationCount = Number(notificationCount)

  if (notificationCount === 0) return ''
  let content = ''
  if (notificationCount > 0 && notificationCount <= 9) {
    content = notificationCount
  } else if (notificationCount > 9) {
    content = '+9'
  }
  return (
    <div className="mdn-Avatar-notification mdn-Avatar-notification">
      {content}
    </div>
  )
}

export default function Avatar(props: AvatarProps) {
  const { imageSrc, imageAlt, notificationCount, sm = false, md = false, lg = false, ...rest } = props

  let spanClassName = 'sm'
  if (md) {
    spanClassName = 'md'
  } else if (lg) {
    spanClassName = 'lg'
  }
  return (
    <div {...rest} className={resolveProps(props, config, 'Avatar')}>
      {imageSrc ? (
        <div className="mdn-Avatar-image">
          <img
            src={imageSrc}
            alt={imageAlt}
            role="img"
          />
        </div>
      ) : (
        <span
          className={
            'mdn-Avatar-icon mdn-Icon-minha-claro mdn-Icon--' + spanClassName
          }
        ></span>
      )}
      {(notificationCount) &&
        renderNotication(notificationCount)}
    </div>
  )
}
